//material-ui
import { PaletteColorOptions } from '@mui/material/styles';

//project-import
import { ThemeMode } from 'config';

//assets
import { PalettesProps } from '@ant-design/colors';

// types
import { PaletteThemeProps } from 'types/theme';

// ==============================|| PRESET THEME — MONO (BRANCO / CINZA / PRETO) ||============================== //

export default function Theme1(colors: PalettesProps, mode: ThemeMode): PaletteThemeProps {
  const { grey } = colors;
  const greyColors: PaletteColorOptions = {
    0: grey[0],
    50: grey[1],
    100: grey[2],
    200: grey[3],
    300: grey[4],
    400: grey[5],
    500: grey[6],
    600: grey[7],
    700: grey[8],
    800: grey[9],
    900: grey[10],
    A50: grey[15],
    A100: grey[11],
    A200: grey[12],
    A400: grey[13],
    A700: grey[14],
    A800: grey[16]
  };
  const contrastOnDark = '#FFFFFF';
  const contrastOnLight = '#000000';

  // Primário = preto (CTAs sólidos) no light; branco no dark — paleta neutra
  let primaryColors = [
    '#FAFAFA',
    '#F5F5F5',
    '#E5E5E5',
    '#D4D4D4',
    '#737373',
    '#000000',
    '#171717',
    '#0A0A0A',
    '#000000',
    '#000000'
  ];
  let primaryContrastText = contrastOnDark;

  let errorColors = ['#FFE7D3', '#FF805D', '#FF4528', '#DB271D', '#930C1A'];
  // Aviso / info / sucesso só em escala de cinza (interface “flat”)
  let warningColors = ['#FAFAFA', '#F0F0F0', '#D4D4D4', '#737373', '#404040'];
  let infoColors = ['#FAFAFA', '#F5F5F5', '#E5E5E5', '#A3A3A3', '#525252'];
  let successColors = ['#FAFAFA', '#F0F0F0', '#E5E5E5', '#737373', '#262626'];

  if (mode === ThemeMode.DARK) {
    primaryColors = [
      '#171717',
      '#262626',
      '#404040',
      '#525252',
      '#A3A3A3',
      '#FFFFFF',
      '#F5F5F5',
      '#E5E5E5',
      '#FAFAFA',
      '#FFFFFF'
    ];
    primaryContrastText = contrastOnLight;
    errorColors = ['#341d1b', '#b03725', '#dd3f27', '#e9664d', '#fbd6c9'];
    warningColors = ['#27272a', '#3f3f46', '#71717a', '#a1a1aa', '#d4d4d8'];
    infoColors = ['#27272a', '#3f3f46', '#52525b', '#a1a1aa', '#e4e4e7'];
    successColors = ['#27272a', '#3f3f46', '#52525b', '#d4d4d8', '#fafafa'];
  }

  return {
    primary: {
      lighter: primaryColors[0],
      100: primaryColors[1],
      200: primaryColors[2],
      light: primaryColors[3],
      400: primaryColors[4],
      main: primaryColors[5],
      dark: primaryColors[6],
      700: primaryColors[7],
      darker: primaryColors[8],
      900: primaryColors[9],
      contrastText: primaryContrastText
    },
    secondary: {
      lighter: greyColors[100],
      100: greyColors[100],
      200: greyColors[200],
      light: greyColors[300],
      400: greyColors[400],
      main: greyColors[500]!,
      600: greyColors[600],
      dark: greyColors[700],
      800: greyColors[800],
      darker: greyColors[900],
      A100: greyColors[0],
      A200: greyColors.A400,
      A300: greyColors.A700,
      contrastText: mode === ThemeMode.DARK ? greyColors[900]! : contrastOnLight
    },
    error: {
      lighter: errorColors[0],
      light: errorColors[1],
      main: errorColors[2],
      dark: errorColors[3],
      darker: errorColors[4],
      contrastText: contrastOnDark
    },
    warning: {
      lighter: warningColors[0],
      light: warningColors[1],
      main: warningColors[2],
      dark: warningColors[3],
      darker: warningColors[4],
      contrastText: mode === ThemeMode.DARK ? greyColors[900]! : contrastOnLight
    },
    info: {
      lighter: infoColors[0],
      light: infoColors[1],
      main: infoColors[2],
      dark: infoColors[3],
      darker: infoColors[4],
      contrastText: mode === ThemeMode.DARK ? greyColors[900]! : contrastOnLight
    },
    success: {
      lighter: successColors[0],
      light: successColors[1],
      main: successColors[2],
      dark: successColors[3],
      darker: successColors[4],
      contrastText: mode === ThemeMode.DARK ? greyColors[900]! : contrastOnLight
    },
    grey: greyColors
  };
}
